
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-12-28-tsl-uniforms",
      function () {
        return require("private-next-pages/blogs/2025-12-28-tsl-uniforms/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-12-28-tsl-uniforms"])
      });
    }
  